export default __webpack_public_path__ + "static/media/features8.8c5333de.jpg";